import {
  mocDenNgayHoaDon,
  mocTuNgayHoaDon,
} from "../../../helpers/mocNgayLamMoi";
import { IDieuChinhRequest } from "../../../model/request/hoa-don-dien-tu/IDieuChinhRequest";
import { IHoaDonDienTuPagingRequest } from "../../../model/request/hoa-don-dien-tu/IHoaDonDienTuPagingRequest";
import {
  IBienLaiThuViewModel,
  ITrangThaiXuatHoaDon,
} from "../../../model/respone/bien-lai/IBienLaiThu";
import { IPhatHanhResponse } from "../../../model/respone/hoa-don-dien-tu/IPhatHanhResponse";
import { IPagingResult } from "../../../model/respone/IPagingResult";
import { IHoaDonDienTuActionTypes } from "../../action-types/hoa-don/IHoaDonDienTuAction";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IHoaDonDienTuReducer } from "../../reducer-model/hoa-don/IHoaDonDienTuReducer";

const iniState: IHoaDonDienTuReducer = {
  bienLais: {} as IPagingResult<IBienLaiThuViewModel[]>,
  request: {
    id_hes: [],
    hoc_ky: 0,
    nam_hoc: "",
    id_lops: [],
    id_nganhs: [],
    id_thu_chis: [],
    tinh_chat_hocs: [],
    ky_dang_kys: [],
    id_doi_tuongs: [],
    khoa_hocs: [],
    page_index: 0,
    page_size: 100,
    search_key: "",
    id_chuyen_nganhs: [],
    id_khoas: [],
    id_hinh_thuc_thanh_toans: [],
    nguoi_thu: "",
    id_co_sos: [],
    trang_thai_hoa_don: "all",
    trang_thai_xuat_hoa_don: "all",
    is_all_hk_namhoc: true,
    id_nhom_thu_chis: [],
    visible_columns: [],
    ky_hieus: [],
    // Mặc định lọc theo ngày thu hôm nay khi lần đầu truy cập module (theo phiên).
    // Lấy qua mocNgayLamMoi để nút Làm mới kéo mốc sang ngày mới khi tab để qua đêm.
    tu_ngay_thu: mocTuNgayHoaDon.lay() as any,
    den_ngay_thu: mocDenNgayHoaDon.lay() as any,
  } as IHoaDonDienTuPagingRequest,
  status: eReducerStatusBase.is_not_initialization,
  idSelections: [],
  isShowFilter: false,
  isShowDanhSachXuat: false,
  hoaDonDienTuChonXuats: [],
} as IHoaDonDienTuReducer;

export const hoaDonDienTuReducer = (
  state: IHoaDonDienTuReducer = iniState,
  action: IHoaDonDienTuActionTypes,
): IHoaDonDienTuReducer => {
  switch (action.type) {
    case "HOA_DON_DIEN_TU_LOAD_START":
      return {
        ...state,
        bienLais: {} as IPagingResult<IBienLaiThuViewModel[]>,
        request: action.payload,
        status: eReducerStatusBase.is_loading,
      };
    case "HOA_DON_DIEN_TU_LOAD_SUCCESS":
      return {
        ...state,
        bienLais: action.payload,
        status: eReducerStatusBase.is_completed,
      };
    case "HOA_DON_DIEN_TU_LOAD_ERRR":
      return {
        ...state,
        bienLais: {} as IPagingResult<IBienLaiThuViewModel[]>,
        status: eReducerStatusBase.is_completed,
      };
    case "HOA_DON_DIEN_TU_CHANGE_REQUEST": {
      // Chỉ paging mới auto-reload. Filter/search/sort/scope yêu cầu "Làm mới".
      const reloadKeys = ["page_index", "page_size"];
      const keys = Object.keys(action.payload);
      const isReload = keys.length > 0 && keys.every((k) => reloadKeys.includes(k));
      return {
        ...state,
        ...(isReload && { status: eReducerStatusBase.is_need_reload }),
        request: {
          ...state.request,
          ...action.payload,
        },
      };
    }
    // case "HOA_DON_DIEN_TU_SHOW_DETAIL_MODAL":
    //   return {
    //     ...state,
    //     idShowViewDetail: action.payload,
    //   };
    // case "HOA_DON_DIEN_TU_HIDE_DETAIL_MODAL":
    //   return {
    //     ...state,
    //     idShowViewDetail: 0,
    //   };
    case "HOA_DON_DIEN_TU_SHOW_HIDE_FILTER":
      return {
        ...state,
        isShowFilter: action.payload,
      };
    case "HOA_DON_DIEN_TU_SELECTED_ID":
      return {
        ...state,
        idSelections: action.payload,
      };
    case "HOA_DON_DIEN_TU_PHAT_HANH_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "HOA_DON_DIEN_TU_PHAT_HANH_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        request: {
          ...state.request,
        },
        hoaDonDienTuView: undefined,
      };
    case "HOA_DON_DIEN_TU_PHAT_HANH_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
      };
    case "HOA_DON_DIEN_TU_PHAT_HANH_MULTIPLE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
        hoaDonDienTuChonXuats: state.hoaDonDienTuChonXuats.map((g) => {
          return {
            ...g,
            trangThaiXuatHoaDon: {
              message: "",
              status: eReducerStatusBase.is_saving,
            },
          };
        }),
      };
    case "HOA_DON_DIEN_TU_PHAT_HANH_MULTIPLE_SUCCESS": {
      /*
        ★ CHỐT TRẠNG THÁI NGAY KHI LỜI GỌI TRẢ VỀ.
        Trước đây chỗ này chỉ đặt cờ nạp lại danh sách, còn trạng thái từng dòng trong bảng "Danh
        sách xuất hóa đơn" trông cả vào SignalR. Máy chủ chưa bật hub là dòng vừa phát hành xong
        vẫn hiện "chưa phát hành" (và còn quay vòng "đang lưu") ⇒ người dùng bấm phát hành lần nữa
        ⇒ nhà phát hành nhận hóa đơn TRÙNG. Nay máy chủ trả kèm trạng thái đọc lại từ CSDL.
      */
      const ketQuas = (action.payload ?? []) as IPhatHanhResponse[];
      const daXuatTheoId = new Map<number, boolean>(
        ketQuas.map((x) => [x.id_bien_lai, x.is_success]),
      );
      const chotTrangThai = (g: IBienLaiThuViewModel) =>
        daXuatTheoId.has(g.id_bien_lai)
          ? {
              ...g,
              trang_thai_xuat_hd: !!daXuatTheoId.get(g.id_bien_lai),
            }
          : g;
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        request: {
          ...state.request,
        },
        hoaDonDienTuChonXuats: state.hoaDonDienTuChonXuats.map((g) => ({
          ...chotTrangThai(g),
          trangThaiXuatHoaDon: {
            // Giữ lời nhắn SignalR nếu có; không có thì để trống cho khỏi treo "đang lưu".
            message: g.trangThaiXuatHoaDon?.message ?? "",
            status: eReducerStatusBase.is_saved,
          } as ITrangThaiXuatHoaDon,
        })),
        bienLais: {
          ...state.bienLais,
          data: state.bienLais.data.map(chotTrangThai),
        },
      };
    }
    case "HOA_DON_DIEN_TU_PHAT_HANH_MULTIPLE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
        hoaDonDienTuChonXuats: state.hoaDonDienTuChonXuats.map((g) => {
          return {
            ...g,
            trangThaiXuatHoaDon: {
              status: eReducerStatusBase.is_saved,
              message: g.trangThaiXuatHoaDon.message,
            },
          };
        }),
      };
    case "HOA_DON_DIEN_TU_PHAT_HANH_MULTIPLE_CANCEL":
      return {
        ...state,
        hoaDonDienTuChonXuats: [],
        isShowDanhSachXuat: false,
        idSelections: [],
      };
    case "HOA_DON_DIEN_TU_PHAT_HANH_MULTIPLE_SHOWHIDE_MODAL":
      return {
        ...state,
        isShowDanhSachXuat: action.payload,
      };
    case "HOA_DON_DIEN_TU_SHOW_DIEU_CHINH_MODAL":
      return {
        ...state,
        isShowDieuChinhModal: true,
        dieuChinhEditing: {
          id_bien_lai: action.payload,
          ly_do_dieu_chinh: "",
        } as IDieuChinhRequest,
      };
    case "HOA_DON_DIEN_TU_HIDE_DIEU_CHINH_MODAL":
      return {
        ...state,
        isShowDieuChinhModal: false,
        dieuChinhEditing: undefined,
      };
    case "HOA_DON_DIEN_TU_DIEU_CHINH_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "HOA_DON_DIEN_TU_DIEU_CHINH_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowDieuChinhModal: false,
        dieuChinhEditing: undefined,
      };
    case "HOA_DON_DIEN_TU_DIEU_CHINH_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
      };
    case "HOA_DON_DIEN_TU_HUY_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "HOA_DON_DIEN_TU_HUY_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "HOA_DON_DIEN_TU_HUY_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
      };
    case "HOA_DON_DIEN_TU_SYNC_STATUS_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
        isShowsyncing: true,
        processId: action.payload.process_id,
      };
    case "HOA_DON_DIEN_TU_SYNC_STATUS_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "HOA_DON_DIEN_TU_SYNC_STATUS_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
      };
    case "HOA_DON_DIEN_TU_CLOSE_SYNCING_MODAL":
      return {
        ...state,
        isShowsyncing: false,
      };
    case "HOA_DON_DIEN_TU_VIEW_DETAIL_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
        // XÓA nội dung cũ ngay khi bắt đầu tải hóa đơn khác. Không xóa thì lần bấm sau mà lỗi,
        // modal vẫn treo NGUYÊN hóa đơn của lần bấm trước -> nhìn y như "bấm ký hiệu nào cũng ra
        // một hóa đơn", trong khi thật ra là lấy hóa đơn thứ hai thất bại.
        hoaDonDienTuView: undefined,
      };
    case "HOA_DON_DIEN_TU_VIEW_DETAIL_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
        hoaDonDienTuView: action.payload,
      };
    case "HOA_DON_DIEN_TU_VIEW_DETAIL_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
        hoaDonDienTuView: undefined,
      };
    case "HOA_DON_DIEN_TU_EXPORT_HOA_DON_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "HOA_DON_DIEN_TU_VIEW_DETAIL_HIDE_MODAL":
      return {
        ...state,
        hoaDonDienTuView: undefined,
      };
    case "HOA_DON_DIEN_TU_PREVIEW_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
        hoaDonDienTuChonXuats: state.hoaDonDienTuChonXuats.map((g) => {
          if (g.id_bien_lai === action.payload.id_bien_lai) {
            return {
              ...g,
              trangThaiXuatHoaDon: {
                message: "",
                status: eReducerStatusBase.is_saving,
              },
            };
          }
          return g;
        }),
      };
    case "HOA_DON_DIEN_TU_PREVIEW_SUCCESS": {
      /*
        ★ "Xem trước" thực chất đã ĐẨY BẢN NHÁP sang nhà phát hành (VNPT InsertAsync /
          MISA PushInvoiceAsync). Lưới chính tô trạng thái theo `refID`, nên phải ghi mã nháp vừa
          nhận vào ĐÚNG dòng đó — không thì dòng vẫn đỏ "Chưa phát hành" cho tới khi bấm Làm mới,
          nhìn như chưa làm gì (user báo 19/08/2026).
      */
      const refMoi = action.payload?.ref_id ?? "";
      const danhDauNhap = (g: IBienLaiThuViewModel) =>
        g.id_bien_lai === action.payload.id_bien_lai
          ? { ...g, refID: g.refID || refMoi || g.refID }
          : g;
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
        hoaDonDienTuView: action.payload,
        bienLais: {
          ...state.bienLais,
          data: (state.bienLais?.data ?? []).map(danhDauNhap),
        },
        hoaDonDienTuChonXuats: state.hoaDonDienTuChonXuats.map((g) => {
          if (g.id_bien_lai === action.payload.id_bien_lai) {
            return {
              ...danhDauNhap(g),
              daCoBanNhap: true,
              trangThaiXuatHoaDon: {
                message: "",
                status: eReducerStatusBase.is_completed,
              },
            };
          }
          return g;
        }),
      };
    }
    case "HOA_DON_DIEN_TU_PREVIEW_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
        hoaDonDienTuChonXuats: state.hoaDonDienTuChonXuats.map((g) => {
          return {
            ...g,
            trangThaiXuatHoaDon: {
              message: "",
              status: eReducerStatusBase.is_completed,
            },
          };
        }),
      };
    case "HOA_DON_DIEN_TU_PHAT_HANH_MULTIPLE_SELECTION":
      const chooses = Array.from(
        new Map(
          [...state.hoaDonDienTuChonXuats, ...action.payload.data]
            .filter((g) => !action.payload.idRemove.includes(g.id_bien_lai))
            .map((item) => [item.id_bien_lai, item]),
        ).values(),
      );
      return {
        ...state,
        hoaDonDienTuChonXuats: chooses,
        idSelections: chooses.map((g) => g.id_bien_lai),
        isShowDanhSachXuat:
          state.isShowDanhSachXuat ||
          (state.hoaDonDienTuChonXuats.length === 0 && chooses.length > 0),
      };
    case "HOA_DON_DIEN_TU_PHAT_HANH_MULTIPLE_CHANGE_LOAIHOADON":
      return {
        ...state,
        hoaDonDienTuChonXuats: state.hoaDonDienTuChonXuats.map((g) => {
          if (g.id_bien_lai === action.payload.id_bien_lai) {
            return {
              ...g,
              idConfigInvoice: action.payload.data,
            };
          }
          return g;
        }),
      };
    case "HOA_DON_DIEN_TU_CHANGE_TRANGTHAI_XUATHOADON":
      return {
        ...state,
        hoaDonDienTuChonXuats: state.hoaDonDienTuChonXuats.map((g) => {
          if (g.id_bien_lai === action.payload.id_bien_lai) {
            return {
              ...g,
              trang_thai_xuat_hd: action.payload.data.is_success,
              trangThaiXuatHoaDon: {
                message: action.payload.data.message,
                status: eReducerStatusBase.is_saved,
              } as ITrangThaiXuatHoaDon,
            };
          }
          return g;
        }),
        bienLais: {
          ...state.bienLais,
          data: state.bienLais.data.map((g) => {
            if (g.id_bien_lai === action.payload.id_bien_lai) {
              return {
                ...g,
                trang_thai_xuat_hd: action.payload.data.is_success,
              };
            }
            return g;
          }),
        },
      };

    case "HOA_DON_DIEN_TU_PHAT_HANH_NHAP_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "HOA_DON_DIEN_TU_PHAT_HANH_NHAP_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        request: {
          ...state.request,
        },
        hoaDonDienTuView: undefined,
      };
    case "HOA_DON_DIEN_TU_PHAT_HANH_NHAP_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
      };

    case "HOA_DON_DIEN_TU_EXPORT_HOA_DON_SUCCESS":
    case "HOA_DON_DIEN_TU_EXPORT_HOA_DON_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
      };
    case "HOA_DON_DIEN_TU_EXPORT_EXCEL_CHON_XUAT_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "HOA_DON_DIEN_TU_EXPORT_EXCEL_CHON_XUAT_SUCCESS":
    case "HOA_DON_DIEN_TU_EXPORT_EXCEL_CHON_XUAT_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "HOA_DON_DIEN_TU_EXPORT_EXCEL_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "HOA_DON_DIEN_TU_EXPORT_EXCEL_SUCCESS":
    case "HOA_DON_DIEN_TU_EXPORT_EXCEL_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
      };
    default:
      return state;
  }
};
